import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';
import { InputSearchCodigoProps } from './types';

const InputSearchCodigo: React.FC<InputSearchCodigoProps> = ({
  label = 'Código:',
  placeholder = 'Buscar por código',
  value,
  onChange,
  onSearch,
  onBlur,
  isLoading = false,
  inputSize = 'medium',
  fullWidth = false,
  width,
}) => {
  return (
    <S.SearchContainer fullWidth={fullWidth} width={width}>
      <S.Label>{label}</S.Label>
      <S.SearchInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        inputSize={inputSize}
      />
      <S.SearchButton onClick={onSearch} disabled={isLoading} inputSize={inputSize}>
        <FontAwesomeIcon icon={faSearch} />
      </S.SearchButton>
    </S.SearchContainer>
  );
};

export default InputSearchCodigo;
